import { Component, OnInit } from '@angular/core';
import { LocalStorage } from 'app/shared/constants/local-storage.constant';
import { LocalStorageService } from 'app/shared/service/local-storage.service';
import { SharedService } from 'app/shared/service/shared.service';
import { ToasterService } from 'app/shared/service/toaster.service';
import { AuthenticatedUserDto } from 'shared/service-proxies/models/authenticated-user-dto.model';
import { ChangePasswordDto } from 'shared/service-proxies/models/change-password-dto.model';
import { UpdateUserDto } from 'shared/service-proxies/models/update-user-dto.model';
import { UserServiceProxy } from 'shared/service-proxies/services/user.service';

@Component({
  selector: 'app-change-username',
  templateUrl: './change-username.component.html',
  styleUrls: ['./change-username.component.scss']
})
export class ChangeUsernameComponent implements OnInit {

  changeUserDialog: boolean = false;
  currentUser: AuthenticatedUserDto = new AuthenticatedUserDto();
  changeUsername: any
  allowSave: boolean = false;
  constructor(private _userServiceProxy: UserServiceProxy,
    private _toasterService: ToasterService,
    private _localStorageService: LocalStorageService,
    private _sharedService: SharedService) {
  }

  ngOnInit(): void {
    this.currentUser = this._localStorageService.getData(LocalStorage.CURRENT_USER);
    this._sharedService.openChangeUsername.subscribe(isOpen => {
      this.changeUserDialog = isOpen;
    })
  }

  open() {
    this.changeUserDialog = true;
  }

  saveUser() {
    if (this.changeUsername && this.changeUsername.length >= 4) {
      this._userServiceProxy.updateUserName(this.changeUsername).subscribe(response => {
        if (response.isSuccess) {
          this._toasterService.toastSuccess("Username Changed Successfully")
          this.changeUserDialog = false;
          this.changeUsername = null;
        }
        else {
          this._toasterService.showApiValidation(response);
        }
      })
    }
  }
  Validateusername() {
    if (this.changeUsername) {
      this._userServiceProxy.validateUserName(this.changeUsername).subscribe(response => {
        if (!response.isSuccess)
          this._toasterService.showApiValidation(response);
        else
          this.allowSave = true;
      })
    }
  }
  hideDialog() {
    this.changeUsername = '';
    this.changeUserDialog = false;
  }
  onChangeInput(): boolean {
    this.allowSave = false;
    return true;
  }
}